// frontend/src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Lazy load components
const Home = lazy(() => import('./Home'));
const Markets = lazy(() => import('./components/MarketOverview'));
const News = lazy(() => import('./components/News'));
const Landing = lazy(() => import('./components/Landing'));
function App() {
    return (
        <ThemeProvider>
            <Router>
                <div className="app">
                    <Header />
                    <Suspense fallback={<div>Loading...</div>}>
                        <main className="main-content">
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="/markets" element={<Markets />} />
                                <Route path="/news" element={<News />} />
                            </Routes>
                        </main>
                    </Suspense>
                    <ToastContainer />
                    <ScrollToTop />
                </div>
            </Router>
        </ThemeProvider>
    );
}

export default App;
